export enum Environment {
  Development = "development",
  Production = "production",
  Test = "test",
}

export function isDevelopment(): boolean {
  return (
    process.env.NODE_ENV === Environment.Development || !process.env.NODE_ENV
  );
}

export function isProduction(): boolean {
  return process.env.NODE_ENV === Environment.Production;
}

export function isTest(): boolean {
  return process.env.NODE_ENV === Environment.Test;
}
